export default __webpack_public_path__ + "static/media/PVLC-2.6c9eb882.png";